<template>
  <div
    :class="_.block"
    :style="{
      '--buy-width': theme.buyWidth ? $transformPx(theme.buyWidth) : '100%',
    }"
  >
    <img
      v-track="{
        name: '自定义块',
        id: `${componentId}`,
        resource: data[0],
      }"
      :src="data[0].icon"
      :class="_.image"
      @click="$dmbcResourceClick(data[0])"
    />

    <img
      v-if="theme.btn1Config && theme.btn1Config.image"
      :src="theme.btn1Config.image"
      :class="_.btn1"
      :style="{
        top: $transformPx(theme.btn1Config.top) + 'px',
        right: $transformPx(theme.btn1Config.right) + 'px',
      }"
      alt=""
      @click="$dmbcResourceClick(theme.btn1Config.routeUrl)"
    />

    <img
      v-if="theme.btn2Config && theme.btn2Config.image"
      :src="theme.btn2Config.image"
      :class="_.btn2"
      :style="{
        top: $transformPx(theme.btn2Config.top) + 'px',
      }"
      alt=""
      @click="handleJumpUrl(theme.btn2Config.routeUrl)"
    />

    <div
      v-if="
        $globalModel &&
        $globalModel.state &&
        $globalModel.state.inWechatWebView &&
        path
      "
      :class="_.cover"
      :style="{
        top: $transformPx(theme.btn2Config.top) + 'px',
      }"
    >
      <div :class="_.trigger" @click.stop.prevent>
        <wx-open-launch-weapp :class="_.trigger" :username="appId" :path="path">
          <script type="text/wxtag-template">
            <style>
              .wx-open-launch-weapp-trigger {
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                z-index: 1;
                opacity: 0;
              }
            </style>
            <div class="wx-open-launch-weapp-trigger"></div>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data() {
      return {
        appId: '', //小程序原始ID gh_3639c683d45e
        path: '',
      }
    },
    mounted() {
      if (this.theme?.btn2Config?.routeUrl) {
        const path = this.theme.btn2Config.routeUrl
        if (path.indexOf('gh_') > -1) {
          this.path = path.split(';')[1]
          this.appId = path.split(';')[0]
        }
      }

      console.log(this.theme)
    },
    methods: {
      async handleJumpUrl(url) {
        if (url.indexOf('gh_') > -1) {
          const gh_appId = url.split(';')[0]
          const path = url.split(';')[1]
          await this.$dcb.navigateToMiniProgram({
            appId: gh_appId,
            path,
          })
        } else {
          this.$dmbcResourceClick(url)
        }
      },
    },
  })
</script>

<style lang="scss" module="_">
  // 之前单个img的写法可能受父级 flex: 1 影响图片在ios16以下版本会出问题
  .block {
    font-size: 0;

    .image {
      display: block;
      width: 100%;
      border-radius: var(--border-radius);
    }
    .btn1 {
      position: absolute;
      top: 18px;
      right: 35px;
      width: 95px;
      height: 24px;
    }
    .btn2 {
      position: absolute;
      top: 134px;
      left: 50%;
      transform: translateX(-50%);
      width: 209px;
      height: 46px;
    }
    .cover {
      position: absolute;
      top: 134px;
      left: 50%;
      transform: translateX(-50%);
      width: 209px;
      height: 46px;

      .trigger {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 1;
        opacity: 0;
      }
    }
  }
</style>
